function groupIntegerPart(
  value: string,
): string {
  return value.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    '.',
  );
}


function joinFormattedParts(
  parts: Intl.NumberFormatPart[],
): string {
  return parts
    .map((part) =>
      part.type === 'integer'
        ? groupIntegerPart(part.value)
        : part.value
    )
    .join('');
}


export function formatMarginCenterNumber(
  value: number | null | undefined,
  maximumFractionDigits = 2,
): string {
  if (value === null || value === undefined) {
    return '—';
  }

  return joinFormattedParts(
    new Intl.NumberFormat(
      'es-ES',
      {
        useGrouping: false,
        maximumFractionDigits,
      },
    ).formatToParts(value),
  );
}


export function formatMarginCenterCurrency(
  value: number | null | undefined,
  currencyCode: string | null,
  maximumFractionDigits = 2,
): string {
  if (value === null || value === undefined) {
    return '—';
  }

  if (!currencyCode) {
    return formatMarginCenterNumber(
      value,
      maximumFractionDigits,
    );
  }

  try {
    return joinFormattedParts(
      new Intl.NumberFormat(
        'es-ES',
        {
          style: 'currency',
          currency: currencyCode,
          useGrouping: false,
          maximumFractionDigits,
        },
      ).formatToParts(value),
    );
  } catch {
    return formatMarginCenterNumber(
      value,
      maximumFractionDigits,
    );
  }
}